"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _react = _interopRequireWildcard(require("react"));
var _iconsMaterial = require("@mui/icons-material");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    hintIcon: {
      color: "".concat(theme.palette.primary[500], " !important"),
      fontSize: '1rem !important',
      position: 'absolute',
      top: '0'
    },
    tooltip: {
      background: 'white !important',
      border: '1px solid black !important',
      color: 'black !important',
      fontSize: '0.8rem !important',
      padding: '0.6rem !important',
      whiteSpace: 'pre-wrap'
    },
    tooltipClose: {
      textAlign: 'end !important',
      lineHeight: '1em !important',
      position: 'relative !important',
      left: '0.4em !important',
      bottom: '0.6em !important'
    },
    tooltipCloseButton: {
      margin: '0 !important',
      padding: '0 !important'
    },
    tooltipCloseIcon: {
      color: "".concat(theme.palette.primary[500], " !important"),
      fontSize: '0.8rem !important'
    },
    popper: {
      opacity: '1.0',
      pointerEvents: 'auto'
    }
  };
};
var CustomHint = /*#__PURE__*/function (_Component) {
  function CustomHint() {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomHint);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CustomHint, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      open: false
    });
    (0, _defineProperty2["default"])(_this, "handleTooltipClose", function () {
      _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])(_this, "handleTooltipOpen", function () {
      _this.setState({
        open: true
      });
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomHint, _Component);
  return (0, _createClass2["default"])(CustomHint, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        hint = _this$props.hint,
        buttonStyle = _this$props.buttonStyle;
      return /*#__PURE__*/_react["default"].createElement(_material.ClickAwayListener, {
        onClickAway: this.handleTooltipClose
      }, /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          container: true,
          direction: "column"
        }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          className: classes.tooltipClose
        }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
          "aria-label": "Close tooltip",
          className: classes.tooltipCloseButton
        }, /*#__PURE__*/_react["default"].createElement(_iconsMaterial.Close, {
          className: classes.tooltipCloseIcon
        }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true
        }, hint)),
        onClose: this.handleTooltipClose,
        open: this.state.open,
        disableFocusListener: true,
        disableHoverListener: true,
        disableTouchListener: true,
        placement: "top-start",
        TransitionComponent: _material.Zoom,
        classes: {
          tooltip: classes.tooltip,
          popper: classes.popper
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        "aria-label": "Question hint",
        onClick: this.state.open ? this.handleTooltipClose : this.handleTooltipOpen,
        className: classes.hintButton,
        style: _objectSpread({}, buttonStyle)
      }, /*#__PURE__*/_react["default"].createElement(_iconsMaterial.Help, {
        className: classes.hintIcon
      }))));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomHint);